import { useEffect } from "react";
import api from "../../_helpers/Request/api";
import { useHistory } from "react-router-dom";
const EPuapInProgress = (props: any) => {
    const history = useHistory();
    useEffect(() => {
        getDataEpauap();
    }, []);


    const getDataEpauap = async () => {
        const { data } = await api.post("/EPuap/SendToESP",
            {
                url: localStorage.getItem("ePuapLink")
            }

        );
        if (data) {
            history.push("/EPuapSuccess")
        }
        else {
            history.push("/EPuapFailure")
        }
    }

    return (
        <>
            <div className="container options">
                <p className="h1 mainHeaderTitle mb-5">
                    Trwa prztwarzanie i wysyłanie dokumentu na elektroniczną skrzynkę podawczą
                </p>
            </div>
        </>
    );
};
export { EPuapInProgress }
